/**
 * How old is a pose, and is it old enough that showing it as "here" would be a lie?
 *
 * ★★ This tiny module exists because of a specific failure the console must never
 *    reproduce. On 2026-08-08 the dog's pose gate latched for 44 minutes: lidar at
 *    10 Hz, uplink dropping nothing, every layer reporting healthy — and the pose
 *    frozen at where it had been. Anything that draws a robot from telemetry will
 *    eventually be handed such a pose. The only defence is to keep the pose's OWN
 *    timestamp (hub does: fleetstate.PoseAt) and to render an old one differently.
 *
 *    So the threshold and the wording are not styling decisions, and they are
 *    tested rather than eyeballed.
 */

/** Telemetry carries a pose about once a minute; three missed cycles = suspicious. */
export const POSE_STALE_S = 180;

/**
 * poseAt is unix SECONDS, 0/undefined meaning "the hub never received a pose".
 * Never-reported is stale by definition — there is no position to claim.
 */
export function poseIsStale(poseAt: number | null | undefined, nowS: number): boolean {
  if (!poseAt) return true;
  return nowS - poseAt > POSE_STALE_S;
}

/** Human age, coarse on purpose: "20 分钟" is actionable, "1203 秒" is not. */
export function fmtAge(seconds: number): string {
  if (!isFinite(seconds)) return '?';
  const s = Math.max(0, seconds);
  if (s < 90) return `${Math.round(s)} 秒`;
  if (s < 5400) return `${Math.round(s / 60)} 分钟`;
  return `${(s / 3600).toFixed(1)} 小时`;
}
